import React, { useState } from "react";
import CourseView from "../components/Programs/courseView/courseView";
import Aside from "../modules/SideNav/Aside";

export default function CourseViewLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <CourseView handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}
